
import './OpenSatus_users.scss';
import * as S from '../../../scss/theme';
import fnc from '../../mymod/commFunction';
import HongButton from '../../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HongInput from '../../comm/HongInput';
import UserSetInfoPanel from './UserSetInfoPanel';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';


const OpenSatus_users = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const pageTitle = location.state?.title || '회원 관리';
    const svrUrl = process.env.REACT_APP_SERVER_URL;
    const [list, setList] = useState([]);
    const [selectedSno, setSelectedSno] = useState(null);
    const [useyn, setUseyn] = useState(null);
    const [currentBalance, setCurrentBalance] = useState(0);
    const [callPrice, setCallPrice] = useState(3000);
    const [maxPage, setMaxPage] = useState(0);
    const [userMemo, setUserMemo] = useState('');
    const [billNoteOptions, setBillNoteOptions] = useState([]);
    const [selectedBillNote, setSelectedBillNote] = useState('');
    const [userSetInfo, setUserSetInfo] = useState(null);
    const [isUserSetInfoLoading, setIsUserSetInfoLoading] = useState(false);
    const [orgName, setOrgName] = useState('');
    const [selectedId, setSelectedId] = useState(null);
    const [selectedName, setSelectedName] = useState('');
    const [selectedStCode, setSelectedStCode] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);
    const [sortKey, setSortKey] = useState('sDate');
    const [sortDir, setSortDir] = useState('desc');

        


    useEffect(() => {
        fncSelect_listUsers();
        fncSelect_billNotes();
    }, [isRefresh]);


    
    function fncSelect_listUsers() {

        fnc.sendAxios('/userRoutes/selectUsers', {  }, (res) => {
            if (res && Array.isArray(res)) {
            const newList = getRecords(res);
            setList(newList);
            // console.log(res, 'res=================');
            } else {
            alert('검색에 실패했습니다.');
            }
        });
                
        function getRecords(res) {
            return res.map(item => {
                return {
                    sno: item["sno"],
                    id: item["id"],
                    userId: item["userId"],
                    stCode: item["stCode"],
                    stName: item["stName"],
                    hp: item["hp"],
                    email: item["email"],
                    sDate: item["sDate"],
                    userKind: item["userKind"],
                    eDate: item["eDate"],
                    useyn: item["useyn"],
                    memo: item["memo"],
                    mathpixMaxPage: item["mathpix_maxpage"],
                    totalCharged: item["total_charged"],
                    totalPayment: item["total_payment"],
                    totalUsed: item["total_used"],
                    balance: item["balance"],
                    walletTotalCharged: item["wallet_total_charged"],
                    walletTotalPayment: item["wallet_total_payment"],
                    walletTotalUsed: item["wallet_total_used"],
                    walletBalance: item["wallet_balance"],
                    academyName: item["academyName"],

                };
            });
        }
    }

    function fncSelect_billNotes() {
        fnc.sendAxios('/userRoutes/selectBillNotes', {}, (res) => {
            if (res && Array.isArray(res)) {
                const options = res
                    .map(item => ({
                        value: item.note || '',
                        label: item.note || ''
                    }))
                    .filter(item => item.value !== '');

                setBillNoteOptions(options);
                if (!selectedBillNote && options.length > 0) {
                    setSelectedBillNote(options[0].value);
                }
            } else {
                setBillNoteOptions([]);
            }
        });
    }

    function handleUseyn(useyn) {
        if (!selectedSno) {
            alert('학원을 선택해주세요.');
            return;
        }

        const rtn = window.confirm(`id: ${selectedId}\n사용여부를 변경하시겠습니까?`);
        if (!rtn) return;

        fnc.sendAxios('/userRoutes/updateUseyn', { id: selectedId, useyn }, (res) => {
            if (res && res.success) {
            fncSelect_listUsers();
            setUseyn(useyn);
            } else {
            alert('변경에 실패했습니다.');
            }
        });
    }


    function onClickTr(item, index) {
        setSelectedSno(item.sno);
        setSelectedId(item.id);
        setSelectedName(item.stName || '');
        setUseyn(item.useyn);
        setSelectedStCode(item.stCode);
        setMaxPage(parseInt(item.mathpixMaxPage) || 0);
        setUserMemo(item.memo || '');
        fncSelect_userSetInfo(item.stName, item.hp);
    }

    function fncSelect_userSetInfo(name, hp) {
        setIsUserSetInfoLoading(true);
        fnc.sendAxios('/userRoutes/selectAutogenUserSet', { name, hp }, (res) => {
            if (res && Array.isArray(res) && res[0]) {
                setUserSetInfo({
                    managerName: res[0].managerName,
                    managerHp: res[0].managerHp,
                    dbName: res[0].dbName,
                    useYn: res[0].useYn,
                    smsAcademyName: res[0].smsAcademyName,
                });
            } else {
                setUserSetInfo(null);
            }
            setIsUserSetInfoLoading(false);
        });
    }

    function handleSaveAiCharge() {
        if (!selectedSno) {
            alert('학원을 선택해주세요.');
            return;
        }

        const amount = parseInt(callPrice) || 0;
        if (amount === 0) {
            alert('금액을 입력하세요');
            return;
        }

        const rtn = window.confirm(`id: ${selectedId}\n이름: ${selectedName}\nAI 충전금액 ${amount.toLocaleString()}을 반영하시겠습니까?`);
        if (!rtn) return;

        fnc.sendAxios('/userRoutes/sp_wallet_charge', {
            user_id: selectedId,
            stCode: selectedStCode,
            charge_amount: amount,
            charge_price: amount,
            note: selectedBillNote
        }, (res) => {
            if (res && res.success) {
                fncSelect_listUsers();
                alert('충전이 완료되었습니다.');
            } else {
                alert(res?.message || '충전에 실패했습니다.');
            }
        });
    }

    function handleRefresh() {
        setIsRefresh(prev => !prev);
    }

    function handleUpdateMaxPage() {
        if (!selectedSno) {
            alert('학원을 선택해주세요.');
            return;
        }

        const page = parseInt(maxPage) || 0;
        const rtn = window.confirm(`id: ${selectedId}\n이름: ${selectedName}\nmaxPage를 ${page}로 수정하시겠습니까?`);
        if (!rtn) return;

        fnc.sendAxios('/userRoutes/updateMathpixMaxpage', {
            id: selectedId,
            stCode: selectedStCode,
            mathpix_maxpage: page
        }, (res) => {
            if (res && res.success) {
                fncSelect_listUsers();
            } else {
                alert('변경에 실패했습니다.');
            }
        });
    }

    function handleSaveUserMemo() {
        if (!selectedSno) {
            alert('학원을 선택해주세요.');
            return;
        }

        const rtn = window.confirm(`id: ${selectedId}\n이름: ${selectedName}\n회원 메모를 저장하시겠습니까?`);
        if (!rtn) return;

        fnc.sendAxios('/userRoutes/updateUserMemo', {
            id: selectedId,
            stCode: selectedStCode,
            memo: userMemo || ''
        }, (res) => {
            if (res && res.success) {
                fncSelect_listUsers();
                alert('메모를 저장했습니다.');
            } else {
                alert('변경에 실패했습니다.');
            }
        });
    }

    function handleSort(key) {
        if (sortKey === key) {
            setSortDir(prev => prev === 'asc' ? 'desc' : 'asc');
        } else {
            setSortKey(key);
            setSortDir('asc');
        }
    }

    function parseDateValue(value) {
        if (value === null || value === undefined || value === '') return null;
        if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
        if (typeof value === 'number') {
            const dateFromNumber = new Date(value);
            return Number.isNaN(dateFromNumber.getTime()) ? null : dateFromNumber;
        }

        const raw = String(value).trim();
        if (!raw) return null;

        const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
        const parsed = new Date(normalized);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    function getDateSortValue(value) {
        const parsed = parseDateValue(value);
        return parsed ? parsed.getTime() : Number.NEGATIVE_INFINITY;
    }

    function formatDateTimeForDisplay(value) {
        if (value === null || value === undefined || value === '') {
            return { date: '', time: '' };
        }

        const raw = String(value).trim();
        const rawMatch = raw.match(/^(\d{4}-\d{2}-\d{2})(?:[ T](\d{2}:\d{2}(?::\d{2})?))?/);
        if (rawMatch) {
            return {
                date: rawMatch[1] || '',
                time: rawMatch[2] || ''
            };
        }

        const parsed = parseDateValue(value);
        if (!parsed) return { date: raw, time: '' };

        const year = parsed.getFullYear();
        const month = String(parsed.getMonth() + 1).padStart(2, '0');
        const day = String(parsed.getDate()).padStart(2, '0');
        const hour = String(parsed.getHours()).padStart(2, '0');
        const minute = String(parsed.getMinutes()).padStart(2, '0');
        const second = String(parsed.getSeconds()).padStart(2, '0');

        return {
            date: `${year}-${month}-${day}`,
            time: `${hour}:${minute}:${second}`
        };
    }

    const sortedList = [...list].sort((a, b) => {
        if (!sortKey) return 0;

        if (sortKey === 'sDate' || sortKey === 'eDate') {
            const ta = getDateSortValue(a[sortKey]);
            const tb = getDateSortValue(b[sortKey]);
            return sortDir === 'asc' ? ta - tb : tb - ta;
        }

        const va = a[sortKey] ?? '';
        const vb = b[sortKey] ?? '';
        const isNum = typeof va === 'number' || (va !== '' && !isNaN(Number(va)));
        if (isNum) {
            return sortDir === 'asc' ? Number(va) - Number(vb) : Number(vb) - Number(va);
        }
        const sa = va.toString().toLowerCase();
        const sb = vb.toString().toLowerCase();
        if (sa < sb) return sortDir === 'asc' ? -1 : 1;
        if (sa > sb) return sortDir === 'asc' ? 1 : -1;
        return 0;
    });

    const sortIcon = (key) => {
        if (sortKey !== key) return <FaSort className='sort-icon inactive' />;
        return sortDir === 'asc' ? <FaSortUp className='sort-icon active' /> : <FaSortDown className='sort-icon active' />;
    };

    const SortTh = ({ label, sortkey }) => (
        <th className='th-sort' onClick={() => handleSort(sortkey)}>
            {label}{sortIcon(sortkey)}
        </th>
    );

    const formatNumber = (value) => Number(value || 0).toLocaleString();

    //=========================================
    return (
    <S.Section_100>
        
        <div className='OpenSatus_users'>
        <div className='title-row'>
            <div className='title'>
                {pageTitle}
            </div>
        </div>
        
        <section className='sec-main'>
        <table className="table-hong table-main">
            <thead>
            <tr>
                <th>{list.length}</th>

                <SortTh label='시작일' sortkey='sDate' />
                <SortTh label='ID' sortkey='userId' />
                <SortTh label='이름' sortkey='stName' />
                <SortTh label='휴대폰' sortkey='hp' />
                <SortTh label='이메일' sortkey='email' />
                <SortTh label='사용여부' sortkey='useyn' />
                <SortTh label='결제금액' sortkey='totalPayment' />
                <SortTh label='총 충전 콜' sortkey='totalCharged' />
                <SortTh label='총 사용 콜' sortkey='totalUsed' />
                <SortTh label='잔여콜' sortkey='balance' />
                <SortTh label='maxpg' sortkey='mathpixMaxPage' />
        
            </tr>
            </thead>
            <tbody>
            {sortedList && sortedList.map((item, index) => (
                <tr key={index} onClick={() => onClickTr(item, index)}
                className={selectedSno === item.sno ? 'selected' : ''}>
                <td>{index+1}</td>
                <td>
                    <span>{formatDateTimeForDisplay(item.sDate).date}</span>
                    <br />
                    <span className='date-time-muted'>{formatDateTimeForDisplay(item.sDate).time}</span>
                </td>
                <td>
                    <span className='user-id'>{item.userId}</span>
                    <br/>
                    <span className='user-stcode'>{item.stCode}</span>
                </td>
                <td>{item.stName}</td>
                <td>{item.hp}</td>
                <td>{item.email}</td>

                <td>{item.useyn}</td>
                <td>{formatNumber(item.walletTotalPayment)}</td>
                <td>{formatNumber(item.walletTotalCharged)}</td>
                <td>{formatNumber(item.walletTotalUsed)}</td>
                <td>{formatNumber(item.walletBalance)}</td>
                <td>{formatNumber(item.mathpixMaxPage)}</td>
            
                </tr>
            ))}
            </tbody>

        </table>
        </section>
        <section className='sec-menu'>
            <UserSetInfoPanel info={userSetInfo} isLoading={isUserSetInfoLoading} />

            <div className='memo-controls'>
                {/* <label className='lbl-input'>메모</label> */}
                <HongInput
                    className='input-usermemo'
                    onChange={(e) => setUserMemo(e.target.value)}
                    value={userMemo}
                />
                <HongButton className='btn h-btn-white btn-memo-save' onClick={handleSaveUserMemo}>메모저장</HongButton>
            </div>

            <div className='menu-controls'>
                <HongButton className='btn h-btn-dark' onClick={handleRefresh}>새로고침</HongButton>
                <HongButton className='btn h-btn-green' disabled={useyn === 'Y'} onClick={() => {handleUseyn('Y')}}>사용</HongButton>
                <HongButton className='btn h-btn-red' disabled={useyn === 'N'} onClick={() => {handleUseyn('N')}}>중지</HongButton>
                <label className='lbl-input'>금액:</label>
                <HongInput 
                    isNumber={true}
                    isNegative={true}
                    useComma={true}
                    className='input-callcnt'
                    onChange={(e) => { const price = parseInt((e.target.value || '').replace(/,/g, '')) || 0; setCallPrice(price); }} 
                    value={callPrice} 
                />

                <label className='lbl-input'>청구구분:</label>
                <select
                    className='cmb-bill-note'
                    value={selectedBillNote}
                    onChange={(e) => setSelectedBillNote(e.target.value)}
                >
                    {billNoteOptions.length === 0 && (
                        <option value=''>메모 없음</option>
                    )}
                    {billNoteOptions.map((item, index) => (
                        <option key={`${item.value}-${index}`} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>

                <HongButton className='btn h-btn-dark' onClick={handleSaveAiCharge}>충전하기</HongButton>
                <label className='lbl-tip'>음수 입력시 차감</label>
                <label className='lbl-input'>maxpg</label>
                <HongInput
                    isNumber={true}
                    isNegative={false}
                    useComma={false}
                    className='input-maxpage'
                    onChange={(e) => { const page = parseInt((e.target.value || '').replace(/,/g, '')) || 0; setMaxPage(page); }}
                    value={maxPage}
                />
                <HongButton className='btn h-btn-dark' onClick={handleUpdateMaxPage}>maxPage</HongButton>
            </div>
        </section>
        </div>
    </S.Section_100>
    )};

    export default OpenSatus_users;